// @flow
import styled from '@emotion/styled';
import Button from '@tablekit/button';

export default styled(Button)`
  // see TSW-637
  font-size: 16px !important;
`;
